
import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenProductTaxChangePubSub, OpenProductTaxChangePubSubPayload } from "@utils/pubsubs/PubSub";
import ChangeProductTaxForm from "@components/forms/ChangeProductTaxForm";
import { ProductTaxChangeDataType } from "@/formTypes/ProductTaxChangeDataType";

type ChangeProductTaxOffCanvasProps = {
    onTaxChanged: (taxChange?: ProductTaxChangeDataType) => void
} & DefaultOffCanvasProps

const ChangeProductTaxOffCanvas = (props: ChangeProductTaxOffCanvasProps) => {
    const { btnColor = "primary", className, onTaxChanged } = props;
    const [defaultData, setDefaultData] = useState<ProductTaxChangeDataType>({} as ProductTaxChangeDataType);
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        const unsubscribe = OpenProductTaxChangePubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenProductTaxChangePubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
        setDefaultData(payload.defaultData || {} as ProductTaxChangeDataType);
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const triggerOnTaxChanged = (taxChange?: ProductTaxChangeDataType) => {
        setOpen(false);
        if (onTaxChanged) {
            onTaxChanged(taxChange)
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Ajuste de Porcentaje de impuestos
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert className="mb-4" color="warning">
                            Al seleccionar un tipo de impuestos diferente que el predeterminado para el producto, el cambio que se realize solo se aplicara al producto seleccion y en este documento
                        </Alert>
                        <ChangeProductTaxForm
                            onTaxChanged={triggerOnTaxChanged}
                            defaultData={defaultData}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default ChangeProductTaxOffCanvas;
